import React, { Component, PropTypes } from 'react';
import Button from 'components/Button';
import shallowCompare from 'react-addons-shallow-compare';

import './style.scss';

class FeedButtonItem extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    const { title, text, button, to } = this.props;
    return (
      <div className="FeedButtonItem">
        <h3>{title}</h3>
        <p>{text}</p>
        <Button isYellow to={to}>{button}</Button>
      </div>
    );
  }
}

FeedButtonItem.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  button: PropTypes.string,
  to: PropTypes.string
};

export default FeedButtonItem;



/** WEBPACK FOOTER **
 ** ./src/members/Main/Feed/FeedButtonItem/index.js
 **/